// extracted by mini-css-extract-plugin
export default {"modal":"AZwC0ZxnRUYnfr18KijE","pagination":"Q11ogiTVnCEibrlon2RI"};